import ReactQuill from 'react-quill'
import styled from 'styled-components'

export const StyledQuill = styled(ReactQuill)`
  .ql-editor {
    max-height: 20rem;
    min-height: 3rem;
    overflow-y: auto;
  }

  .ql-container {
    height: auto;
    min-height: 6rem;
  }

  .ql-toolbar.ql-snow {
    border-radius: 8px 8px 0px 0px;
  }

  .ql-container.ql-snow {
    border-radius: 0px 0px 8px 8px;
  }
`
